"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGiftingFlowPreviewStepMessageEditButtonClicked = exports.useGiftingFlowPreviewStepProductEditButtonClicked = exports.useGiftingFlowPreviewStepScheduleGiftButtonClicked = exports.useGiftingFlowPreviewStepSendGiftButtonClicked = exports.useGiftingFlowMessageStepNextButtonClicked = exports.useGiftingFlowSelectGiftStepNextButtonClicked = exports.useGiftingFlowSelectGiftStepProductClicked = exports.useGiftingFlowContactsStepNextButtonClick = exports.useGiftingFlowRemoveContactButtonClicked = exports.useGiftingFlowAddContactsButtonClicked = exports.useGiftingFlowContactTableIsOpened = exports.useGiftingFlowDownloadXLSTemplateButtonClicked = exports.useGiftingFlowEnterContactsButtonClicked = exports.useGiftingFlowDropImportFile = exports.useCampaignsListBatchesListSelectBatch = exports.useCampaignsListBatchesListBackButtonClicked = exports.useCampaignsListSeeAllBatchesButtonClicked = exports.useCampaignsListCampaignSelected = exports.useCampaignsListDetailsToggled = exports.useCampaignsListSetFavoriteClicked = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _events = require("../events");

var _providers = require("../providers");

var _user = require("../../Shared/store/user/user.selectors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useCampaignsListSetFavoriteClicked = function useCampaignsListSetFavoriteClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector2 = (0, _slicedToArray2.default)(_useSelector, 2),
      payload = _useSelector2[0],
      options = _useSelector2[1];

  return (0, _react.useCallback)(function (params) {
    dispatch((0, _events.trackCampaignsListSetFavoriteClicked)(_objectSpread(_objectSpread({}, payload), params), options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListSetFavoriteClicked = useCampaignsListSetFavoriteClicked;

var useCampaignsListDetailsToggled = function useCampaignsListDetailsToggled() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector3 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector4 = (0, _slicedToArray2.default)(_useSelector3, 2),
      payload = _useSelector4[0],
      options = _useSelector4[1];

  return (0, _react.useCallback)(function (params) {
    dispatch((0, _events.trackCampaignsListDetailsToggled)(_objectSpread(_objectSpread({}, payload), params), options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListDetailsToggled = useCampaignsListDetailsToggled;

var useCampaignsListCampaignSelected = function useCampaignsListCampaignSelected() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector5 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector6 = (0, _slicedToArray2.default)(_useSelector5, 2),
      payload = _useSelector6[0],
      options = _useSelector6[1];

  return (0, _react.useCallback)(function (params) {
    dispatch((0, _events.trackCampaignsListCampaignSelected)(_objectSpread(_objectSpread({}, payload), params), options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListCampaignSelected = useCampaignsListCampaignSelected;

var useCampaignsListSeeAllBatchesButtonClicked = function useCampaignsListSeeAllBatchesButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector7 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector8 = (0, _slicedToArray2.default)(_useSelector7, 2),
      payload = _useSelector8[0],
      options = _useSelector8[1];

  return (0, _react.useCallback)(function () {
    dispatch((0, _events.trackCampaignsListSeeAllBatchesButtonClicked)(payload, options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListSeeAllBatchesButtonClicked = useCampaignsListSeeAllBatchesButtonClicked;

var useCampaignsListBatchesListBackButtonClicked = function useCampaignsListBatchesListBackButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector9 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector10 = (0, _slicedToArray2.default)(_useSelector9, 2),
      payload = _useSelector10[0],
      options = _useSelector10[1];

  return (0, _react.useCallback)(function () {
    dispatch((0, _events.trackCampaignsListBatchesListBackButtonClicked)(payload, options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListBatchesListBackButtonClicked = useCampaignsListBatchesListBackButtonClicked;

var useCampaignsListBatchesListSelectBatch = function useCampaignsListBatchesListSelectBatch() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector11 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector12 = (0, _slicedToArray2.default)(_useSelector11, 2),
      payload = _useSelector12[0],
      options = _useSelector12[1];

  return (0, _react.useCallback)(function (params) {
    dispatch((0, _events.trackCampaignsListBatchesListSelectBatch)(_objectSpread(_objectSpread({}, payload), params), options));
  }, [dispatch, payload, options]);
};

exports.useCampaignsListBatchesListSelectBatch = useCampaignsListBatchesListSelectBatch;

var useGiftingFlowDropImportFile = function useGiftingFlowDropImportFile() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector13 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector14 = (0, _slicedToArray2.default)(_useSelector13, 2),
      payload = _useSelector14[0],
      options = _useSelector14[1];

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex.campaignId;

  return (0, _react.useCallback)(function () {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowDropImportFile)(_objectSpread({
        campaignId
      }, payload), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowDropImportFile = useGiftingFlowDropImportFile;

var useGiftingFlowEnterContactsButtonClicked = function useGiftingFlowEnterContactsButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector15 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector16 = (0, _slicedToArray2.default)(_useSelector15, 2),
      payload = _useSelector16[0],
      options = _useSelector16[1];

  return (0, _react.useCallback)(function (campaignId) {
    dispatch((0, _events.trackGiftingFlowEnterContactsButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
      campaignId
    }), options));
  }, [dispatch, payload, options]);
};

exports.useGiftingFlowEnterContactsButtonClicked = useGiftingFlowEnterContactsButtonClicked;

var useGiftingFlowDownloadXLSTemplateButtonClicked = function useGiftingFlowDownloadXLSTemplateButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector17 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector18 = (0, _slicedToArray2.default)(_useSelector17, 2),
      payload = _useSelector18[0],
      options = _useSelector18[1];

  return (0, _react.useCallback)(function (campaignId) {
    dispatch((0, _events.trackGiftingFlowDownloadXLSTemplateButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
      campaignId
    }), options));
  }, [dispatch, payload, options]);
};

exports.useGiftingFlowDownloadXLSTemplateButtonClicked = useGiftingFlowDownloadXLSTemplateButtonClicked;

var useGiftingFlowContactTableIsOpened = function useGiftingFlowContactTableIsOpened() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector19 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector20 = (0, _slicedToArray2.default)(_useSelector19, 2),
      payload = _useSelector20[0],
      options = _useSelector20[1];

  var _useGiftingFlowContex2 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex2.campaignId;

  return (0, _react.useCallback)(function () {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowContactTableIsOpened)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId
      }), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowContactTableIsOpened = useGiftingFlowContactTableIsOpened;

var useGiftingFlowAddContactsButtonClicked = function useGiftingFlowAddContactsButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector21 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector22 = (0, _slicedToArray2.default)(_useSelector21, 2),
      payload = _useSelector22[0],
      options = _useSelector22[1];

  var _useGiftingFlowContex3 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex3.campaignId;

  return (0, _react.useCallback)(function () {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowAddContactsButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId
      }), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowAddContactsButtonClicked = useGiftingFlowAddContactsButtonClicked;

var useGiftingFlowRemoveContactButtonClicked = function useGiftingFlowRemoveContactButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector23 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector24 = (0, _slicedToArray2.default)(_useSelector23, 2),
      payload = _useSelector24[0],
      options = _useSelector24[1];

  var _useGiftingFlowContex4 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex4.campaignId;

  return (0, _react.useCallback)(function (contactInfo) {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowRemoveContactButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId,
        contactInfo
      }), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowRemoveContactButtonClicked = useGiftingFlowRemoveContactButtonClicked;

var useGiftingFlowContactsStepNextButtonClick = function useGiftingFlowContactsStepNextButtonClick() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector25 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector26 = (0, _slicedToArray2.default)(_useSelector25, 2),
      payload = _useSelector26[0],
      options = _useSelector26[1];

  var _useGiftingFlowContex5 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex5.campaignId;

  return (0, _react.useCallback)(function (contactsInfo) {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowContactsStepNextButtonClick)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId,
        contactsInfo
      }), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowContactsStepNextButtonClick = useGiftingFlowContactsStepNextButtonClick;

var useGiftingFlowSelectGiftStepProductClicked = function useGiftingFlowSelectGiftStepProductClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector27 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector28 = (0, _slicedToArray2.default)(_useSelector27, 2),
      payload = _useSelector28[0],
      options = _useSelector28[1];

  var _useGiftingFlowContex6 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex6.campaignId;

  return (0, _react.useCallback)(function (params) {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowSelectGiftStepProductClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId
      }, params), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowSelectGiftStepProductClicked = useGiftingFlowSelectGiftStepProductClicked;

var useGiftingFlowSelectGiftStepNextButtonClicked = function useGiftingFlowSelectGiftStepNextButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector29 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector30 = (0, _slicedToArray2.default)(_useSelector29, 2),
      payload = _useSelector30[0],
      options = _useSelector30[1];

  var _useGiftingFlowContex7 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex7.campaignId;

  return (0, _react.useCallback)(function (params) {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowSelectGiftStepNextButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId
      }, params), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowSelectGiftStepNextButtonClicked = useGiftingFlowSelectGiftStepNextButtonClicked;

var useGiftingFlowMessageStepNextButtonClicked = function useGiftingFlowMessageStepNextButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector31 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector32 = (0, _slicedToArray2.default)(_useSelector31, 2),
      payload = _useSelector32[0],
      options = _useSelector32[1];

  var _useGiftingFlowContex8 = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex8.campaignId;

  return (0, _react.useCallback)(function (formValues) {
    if (campaignId) {
      dispatch((0, _events.trackGiftingFlowMessageStepNextButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        campaignId,
        formValues
      }), options));
    }
  }, [dispatch, payload, options, campaignId]);
};

exports.useGiftingFlowMessageStepNextButtonClicked = useGiftingFlowMessageStepNextButtonClicked;

var useGiftingFlowPreviewStepSendGiftButtonClicked = function useGiftingFlowPreviewStepSendGiftButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector33 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector34 = (0, _slicedToArray2.default)(_useSelector33, 2),
      payload = _useSelector34[0],
      options = _useSelector34[1];

  var _useGiftingFlowContex9 = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex9.batchId;

  return (0, _react.useCallback)(function () {
    if (batchId) {
      dispatch((0, _events.trackGiftingFlowPreviewStepSendGiftButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        batchId
      }), options));
    }
  }, [dispatch, payload, options, batchId]);
};

exports.useGiftingFlowPreviewStepSendGiftButtonClicked = useGiftingFlowPreviewStepSendGiftButtonClicked;

var useGiftingFlowPreviewStepScheduleGiftButtonClicked = function useGiftingFlowPreviewStepScheduleGiftButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector35 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector36 = (0, _slicedToArray2.default)(_useSelector35, 2),
      payload = _useSelector36[0],
      options = _useSelector36[1];

  var _useGiftingFlowContex10 = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex10.batchId;

  return (0, _react.useCallback)(function (presetName) {
    if (batchId) {
      dispatch((0, _events.trackGiftingFlowPreviewStepScheduleGiftButtonClicked)(_objectSpread(_objectSpread({}, payload), {}, {
        batchId,
        presetName
      }), options));
    }
  }, [dispatch, payload, options, batchId]);
};

exports.useGiftingFlowPreviewStepScheduleGiftButtonClicked = useGiftingFlowPreviewStepScheduleGiftButtonClicked;

var useGiftingFlowPreviewStepProductEditButtonClicked = function useGiftingFlowPreviewStepProductEditButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector37 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector38 = (0, _slicedToArray2.default)(_useSelector37, 2),
      payload = _useSelector38[0],
      options = _useSelector38[1];

  return (0, _react.useCallback)(function () {
    dispatch((0, _events.trackGiftingFlowPreviewStepProductEditButtonClicked)(payload, options));
  }, [dispatch, payload, options]);
};

exports.useGiftingFlowPreviewStepProductEditButtonClicked = useGiftingFlowPreviewStepProductEditButtonClicked;

var useGiftingFlowPreviewStepMessageEditButtonClicked = function useGiftingFlowPreviewStepMessageEditButtonClicked() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector39 = (0, _reactRedux.useSelector)(_user.getBaseEventPayload),
      _useSelector40 = (0, _slicedToArray2.default)(_useSelector39, 2),
      payload = _useSelector40[0],
      options = _useSelector40[1];

  return (0, _react.useCallback)(function () {
    dispatch((0, _events.trackGiftingFlowPreviewStepMessageEditButtonClicked)(payload, options));
  }, [dispatch, payload, options]);
};

exports.useGiftingFlowPreviewStepMessageEditButtonClicked = useGiftingFlowPreviewStepMessageEditButtonClicked;